import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface CodeProps {
  children: ReactNode;
  className?: string;
  /** Preserve case and spacing exactly; never uppercase copyable values (spec section 22). */
  title?: string;
}

/** Inline mono for IDs, hashes, keys. Case is preserved. */
export function Code({ children, className, title }: CodeProps) {
  return (
    <code
      title={title}
      className={cn('rounded-sm border border-hair bg-bg px-1 py-px font-mono text-xs-plus text-ink', className)}
    >
      {children}
    </code>
  );
}
